export const ENABLE_RBAC = true;
export const SUPPORTS_AGRICULTURAL = true;

export const POLLY_API_URL = process.env.REACT_APP_POLLY_API_URL || "";
export const POLLY_API_KEY = process.env.REACT_APP_POLLY_API_KEY || "";
export const POLLY_TIMEOUT_MS = 15000;
export const SYNC_API_URL = process.env.REACT_APP_SYNC_API_URL || "";
export const FETCH_AV_SYNC_STATUS_URL = process.env.REACT_APP_FETCH_AV_SYNC_STATUS_URL || "";
export const UPLOAD_API_URL = process.env.REACT_APP_S3_API_URL || "";
export const VOICE_PREF_API_URL = process.env.REACT_APP_VOICE_PREFERENCES_API_URL || "";
export const DOWNLOAD_API_URL = process.env.REACT_APP_DOWNLOAD_API_URL || "";
export const GENERATE_SRT_API_URL =
  process.env.REACT_APP_GENERATE_SRT_API_URL ||
  "https://3vtivjylwl.execute-api.us-east-1.amazonaws.com/dev/generate_srt_files";
export const DELETE_FILES_API_URL =
  process.env.REACT_APP_DELETE_FILES_API_URL ||
  "https://xaqca7at6b.execute-api.us-east-1.amazonaws.com/dev/delete_files";

export const DEFAULT_CONCURRENCY = 3; // simultaneous S3 PUT requests
export const MAX_RETRIES = 3; // attempts per part before giving up
export const BASE_RETRY_DELAY_MS = 800; // exponential back-off base (ms)

export const ACCEPTED_VIDEO_TYPES = ["video/mp4"];
export const ACCEPTED_SRT_TYPES = [
  "application/x-subrip",
  "text/plain",
  "application/octet-stream",
  "",
];
export const MAX_VIDEO_SIZE_BYTES = 1 * 1024 * 1024 * 1024; // 1 GB
export const MAX_SRT_SIZE_BYTES = 50 * 1024; // 50 KB

export const UPLOAD_STATUS = {
  IDLE: "idle",
  UPLOADING: "uploading",
  VERIFYING: "verifying",
  UPLOAD_COMPLETE: "upload_complete",
  UPLOAD_FAILED: "upload_failed",
};

export const SYNC_TRIGGER_STATUS = {
  IDLE: "idle",
  TRIGGERING: "triggering",
  TRIGGERED: "triggered",
  FAILED: "failed",
};

export const UPLOAD_ERROR = {
  SESSION_EXPIRED: "SESSION_EXPIRED",
  DUPLICATE_JOB: "DUPLICATE_JOB",
  NETWORK_ERROR: "NETWORK_ERROR",
  CANCELLED: "Upload cancelled.",
};

export const DOWNLOAD_STATUS = {
  READY: "ready",
  FETCHING: "fetching",
  DOWNLOADING: "downloading",
  DOWNLOADED: "downloaded",
  ERROR: "error",
};

export const FILE_STATUS = {
  PENDING: "pending",
  DOWNLOADING: "downloading",
  DONE: "done",
  ERROR: "error",
};

export const POLL_STATUS = {
  POLLING: "polling",
  COMPLETE: "complete",
  ERROR: "error",
};

export const POLL_INTERVAL_MS = 1 * 60 * 1000; // 60 000 ms

export const ENGINE_LABEL_MAP = {
  generative: "Generative",
  neural: "Neural",
  standard: "Standard",
  "long-form": "Long-form",
  longform: "Long-form",
};

export const ENGINE_STYLE_MAP = {
  Generative: "Standard",
  Neural: "Neural",
  Standard: "Standard",
  "Long-form": "Standard",
};

export const DEFAULT_PREVIEW_TEXTS = {
  German: "Hallo, wie geht es?",
  Spanish: "Hola, ¿cómo estás?",
  French: "Bonjour, ça va?",
  Italian: "Ciao, come stai?",
  Dutch: "Hallo, hoe gaat het?",
  "Portuguese (Brazil)": "Olá, como vai você?",
  Turkish: "Merhaba, nasılsın?",
  "Chinese (Simplified)": "你好，你好吗？",
  Japanese: "こんにちは。",
};

export const STATUS_META = {
  DOWNLOADED: {
    label: "Downloaded",
    color: "#0078d4",
    bg: "#eff6ff",
    dot: "#0078d4",
  },
  COMPLETED: {
    label: "Completed",
    color: "#16a34a",
    bg: "#f0fdf4",
    dot: "#16a34a",
  },
  DELETED: {
    label: "Completed",
    color: "#16a34a",
    bg: "#f0fdf4",
    dot: "#16a34a",
  },
  UPLOADED: {
    label: "Uploaded",
    color: "#d97706",
    bg: "#fffbeb",
    dot: "#f59e0b",
  },
  AV_SYNC_INITIATED: {
    label: "Processing",
    color: "#d97706",
    bg: "#fffbeb",
    dot: "#f59e0b",
  },
  FAILED: { label: "Failed", color: "#dc2626", bg: "#fef2f2", dot: "#dc2626" },
};

export const LANG_STATUS_META = {
  VIDEO_TRANSLATED: {
    label: "Ready",
    color: "#16a34a",
    bg: "#f0fdf4",
    border: "#86efac",
  },
  READY: { label: "Ready", color: "#16a34a", bg: "#f0fdf4", border: "#86efac" },
  PROCESSING: {
    label: "Processing",
    color: "#d97706",
    bg: "#fffbeb",
    border: "#fcd34d",
  },
  FAILED: {
    label: "Failed",
    color: "#dc2626",
    bg: "#fef2f2",
    border: "#fca5a5",
  },
  UPLOADED: {
    label: "Uploaded",
    color: "#d97706",
    bg: "#fffbeb",
    border: "#fcd34d",
  },
  PENDING: {
    label: "Pending",
    color: "#64748b",
    bg: "#f8fafc",
    border: "#cbd5e1",
  },
};

export const COMPLETED_STATUSES = ["COMPLETED", "DELETED"];
export const FILTER_OPTIONS = [
  "ALL",
  "DOWNLOADED",
  "UPLOADED",
  "AV_SYNC_INITIATED",
  "COMPLETED",
  "FAILED",
];
export const SERVICE_FILTER_OPTIONS = [
  { value: "ALL", label: "All Services" },
  { value: "Agricultural", label: "Agricultural" },
  { value: "Positioning", label: "Positioning" },
];

export const STAGE_MAP = {
  QUEUED: { SRT: "active", Audio: "pending", Video: "pending" },
  PROCESSING: { SRT: "active", Audio: "pending", Video: "pending" },
  SRT_TRANSLATION_INITIATED: {
    SRT: "active",
    Audio: "pending",
    Video: "pending",
  },
  SRT_GENERATED: { SRT: "done", Audio: "active", Video: "pending" },
  AUDIO_GENERATED: { SRT: "done", Audio: "done", Video: "active" },
  AUDIO_TRANSLATED: { SRT: "done", Audio: "done", Video: "active" },
  VIDEO_TRANSLATED: { SRT: "done", Audio: "done", Video: "done" },
  FAILED: { SRT: "failed", Audio: "failed", Video: "failed" },
};

export const PIPELINE_STAGES = [
  { key: "SRT", label: "SRT" },
  { key: "Audio", label: "Audio" },
  { key: "Video", label: "Video" },
];

export const GENDER_FILTERS = ["All", "Female", "Male"];
export const ENGINE_FILTERS = ["All", "Generative", "Neural", "Standard", "Long-form"];

export const AVATAR_PALETTE = {
  Female: { bg: "#fce7f3", text: "#be185d", border: "#f9a8d4" },
  Male: { bg: "#dbeafe", text: "#1d4ed8", border: "#93c5fd" },
};

export const ENGINE_META = {
  Generative: {
    label: "Generative",
    bg: "#ede9fe",
    text: "#6d28d9",
    border: "#c4b5fd",
  },
  Neural: {
    label: "Neural",
    bg: "#dcfce7",
    text: "#15803d",
    border: "#86efac",
  },
  Standard: {
    label: "Standard",
    bg: "#f1f5f9",
    text: "#475569",
    border: "#cbd5e1",
  },
  "Long-form": {
    label: "Long-form",
    bg: "#fef3c7",
    text: "#b45309",
    border: "#fcd34d",
  },
};

export const GENDER_META = {
  Female: { symbol: "♀", bg: "#fdf2f8", text: "#9d174d", border: "#f0abfc" },
  Male: { symbol: "♂", bg: "#eff6ff", text: "#1e40af", border: "#93c5fd" },
};

export const VOICE_OPTIONS = [
  {
    id: "en-us-neural",
    label: "English (US) — Neural",
    engine: "Neural TTS",
    active: true,
  },
  {
    id: "en-gb-neural",
    label: "English (GB) — Neural",
    engine: "Neural TTS",
    active: false,
  },
  {
    id: "de-neural",
    label: "German — Neural",
    engine: "Neural TTS",
    active: false,
  },
  {
    id: "fr-neural",
    label: "French — Neural",
    engine: "Neural TTS",
    active: false,
  },
  {
    id: "es-neural",
    label: "Spanish — Neural",
    engine: "Neural TTS",
    active: false,
  },
];

export const PERMISSIONS = {
  ACCESS_APPLICATION: "ACCESS_APPLICATION",
  UPLOAD_FILE: "UPLOAD_FILE",
  RUN_SYNC: "RUN_SYNC",
  DOWNLOAD_FILE: "DOWNLOAD_FILE",
  VIEW_JOB_STATUS: "VIEW_JOB_STATUS",
  MANAGE_VOICE_PREFERENCES: "MANAGE_VOICE_PREFERENCES", // Admin only
};

export const ROLES = {
  ADMIN: "Admin",
  USER: "User",
  DISABLED: "Disabled",
};

export const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: new Set([
    PERMISSIONS.ACCESS_APPLICATION,
    PERMISSIONS.UPLOAD_FILE,
    PERMISSIONS.RUN_SYNC,
    PERMISSIONS.DOWNLOAD_FILE,
    PERMISSIONS.VIEW_JOB_STATUS,
    PERMISSIONS.MANAGE_VOICE_PREFERENCES,
  ]),
  [ROLES.USER]: new Set([
    PERMISSIONS.ACCESS_APPLICATION,
    PERMISSIONS.UPLOAD_FILE,
    PERMISSIONS.RUN_SYNC,
    PERMISSIONS.DOWNLOAD_FILE,
    PERMISSIONS.VIEW_JOB_STATUS,
  ]),
  [ROLES.DISABLED]: new Set([]),
};

export const WIZARD_STEPS = [
  { key: "services", label: "Select Service", route: "/services" },
  { key: "upload", label: "Upload Files", route: "/upload" },
  { key: "sync", label: "Processing", route: "/sync" },
  { key: "download", label: "Download", route: "/download" },
];
export const WIZARD_ROUTES = WIZARD_STEPS.map((s) => s.route);

export const NAV_ITEMS = [
  {
    key: "dashboard",
    label: "Job Status",
    to: "/dashboard",
    permission: PERMISSIONS.VIEW_JOB_STATUS,
    icon: "📋",
  },
  {
    key: "services",
    label: "Select Service",
    to: "/services",
    permission: PERMISSIONS.UPLOAD_FILE,
    icon: "🗂️",
  },
  {
    key: "upload",
    label: "Upload",
    to: "/upload",
    permission: PERMISSIONS.UPLOAD_FILE,
    icon: "⬆️",
  },
  {
    key: "sync",
    label: "Synchronise",
    to: "/sync",
    permission: PERMISSIONS.RUN_SYNC,
    icon: "⚙️",
  },
  {
    key: "download",
    label: "Download",
    to: "/download",
    permission: PERMISSIONS.DOWNLOAD_FILE,
    icon: "⬇️",
  },
  {
    key: "voice-preferences",
    label: "Voice Preferences",
    to: "/voice-preferences",
    permission: PERMISSIONS.MANAGE_VOICE_PREFERENCES,
    icon: "🎙️",
  },
];

// Shared by both Positioning and Agricultural services
export const POSITIONING_LANGUAGES = [
  "German",
  "Spanish",
  "French",
  "Italian",
  "Dutch",
  "Portuguese (Brazil)",
];

// Exclusive to Agricultural service (added on top of positioning)
export const ADDITIONAL_LANGUAGES = ["Turkish", "Chinese (Simplified)", "Japanese"];

// Agricultural = all positioning languages + additional ones
export const AGRICULTURAL_LANGUAGES = [...POSITIONING_LANGUAGES, ...ADDITIONAL_LANGUAGES];

// Moved to src/constants/languageFlags.jsx — import FlagIcon from there.
// Single source of truth, SVG-based, works on all OS including Windows.

export const T3_SERVICES = [
  {
    id: "positioning",
    label: "Positioning",
    languages: POSITIONING_LANGUAGES,
    gradient: "linear-gradient(150deg, #93c5fd 0%, #60a5fa 45%, #3b82f6 100%)",
    accent: "#1d4ed8",
    checkColor: "#1d4ed8",
    bullets: [
      "Designed for business professionals",
      "Supports global communication",
      "Covers major international languages",
    ],
    maxFlags: POSITIONING_LANGUAGES.length,
  },
  {
    id: "agricultural",
    label: "Agricultural",
    languages: AGRICULTURAL_LANGUAGES,
    gradient: "linear-gradient(150deg, #a7c4a0 0%, #7aab70 45%, #4d8645 100%)",
    accent: "#16a34a",
    checkColor: "#16a34a",
    bullets: [
      "Designed for agricultural communities",
      "Supports broader regional languages",
      "Includes local & global languages",
    ],
    maxFlags: AGRICULTURAL_LANGUAGES.length,
  },
];

export const T3_DISCLAIMERS = {
  default:
    "Service selection determines your available language options and features; this can be updated before final confirmation.",
  positioning:
    "Positioning Services is intended for business use; language availability may vary by subscription plan and region.",
  agricultural:
    "Agricultural Services is designed for rural and farming communities; feature access is governed by your service agreement.",
};
// Use these everywhere in components instead of the raw arrays/lists.
// When SUPPORTS_AGRICULTURAL flips to true, every consumer updates automatically.

export const ACTIVE_T3_SERVICES = SUPPORTS_AGRICULTURAL
  ? T3_SERVICES
  : T3_SERVICES.filter((s) => s.id === "positioning");

// All unique languages visible across the active service(s) — used in the popup
export const ACTIVE_LANGUAGES = SUPPORTS_AGRICULTURAL
  ? AGRICULTURAL_LANGUAGES // positioning ∪ additional
  : POSITIONING_LANGUAGES;
